import * as Cesium from "cesium";
import type { DrawingAOIMode } from "../types";

export function createCesiumDrawingAOI(viewer: any, mode: DrawingAOIMode) {
  let handler: any;

  return {
    activate() {
      console.log("Activating Cesium drawing mode:", viewer, mode);

      handler = viewer.screenSpaceEventHandler?.createScreenSpaceHandler();

      handler.setInputAction((click: any) => {
        const cartesian = viewer.scene?.pickPosition(click.position);
        viewer.drawingTool?.addPoint(cartesian);
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },

    deactivate() {
      if (handler) handler.destroy();
    },
  };
}
